export default __webpack_public_path__ + "static/media/1.cc035b0b.png";